import React from "react";

import moment from "moment";

import Calendar from "../../../assets/icons/biCalendar.svg";
import { displayPhoneNumberWithSpace } from "../../../shared/helpers";

import HealthcareProfessionalInformationGuide from "./../../pages/PatientMaterial/Brochures/PDFs/HealthcareProfessionalInformationGuide.pdf";

const ReRegisterFormPharmacy = ({
  stateRegister,
  registerForm,
  handleChangeCheckBox,
}) => {
  return (
    <React.Fragment>
      {stateRegister === 1 && (
        <React.Fragment>
          <h1 className="select-category-txt-register">
            Pharmacy Re-Registration Form
          </h1>

          <hr className="green-hr" />

          <div className="group-back">
            <div>Pharmacy Re-Registration Form</div>
          </div>
          <div className="wrapper-brackground">
            <h2 className="title-details">Pharmacy Details</h2>
            <div className="container">
              <div className="row">
                <div className="col">
                  <label className="disabled">
                    Chief/ Superintendent Pharmacist (or appointed deputy) First
                    Name:*
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    value={registerForm?.first_name}
                    disabled
                  />
                </div>
                <div className="col">
                  <label className="disabled">
                    Chief/ Superintendent Pharmacist (or appointed deputy) Last
                    Name:*
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    value={registerForm?.last_name}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label className="disabled">Pharmacy GMS Number:*</label>
                  <input
                    type="text"
                    name="registration_number"
                    value={registerForm?.pharmacy?.registration_number}
                    disabled
                  />
                </div>
                <div className="col">
                  <label className="disabled">Pharmacy Name:*</label>
                  <input
                    type="text"
                    name="phone_number"
                    value={registerForm?.pharmacy?.name}
                    disabled
                  />
                </div>

                <div className="row">
                  <div className="col">
                    <label className="disabled">
                      Pharmacy Contact Number:*
                    </label>
                    <input
                      type="text"
                      name="phone_number"
                      value={displayPhoneNumberWithSpace(
                        registerForm?.phone_number
                      )}
                      disabled
                    />
                  </div>

                  <div className="col"></div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label className="disabled">
                    Dispensing Pharmacy Address:*
                  </label>
                  <input
                    type="text"
                    name="address1"
                    value={registerForm?.pharmacy?.address?.full_address}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label className="disabled">
                    Delivery Address (if different):
                  </label>
                  <input
                    type="text"
                    name="delivery_address"
                    value={registerForm?.pharmacy?.delivery_address}
                    placeholder="Only complete if different to the address listed above"
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label className="disabled">
                    Ordering Address (If different to delivery address):
                  </label>
                  <input
                    type="text"
                    name="ordering_address"
                    value={registerForm?.pharmacy?.ordering_address}
                    placeholder="Only complete if different to the address listed above"
                    disabled
                  />
                </div>
              </div>
            </div>

            <h2 className="title-details">Account Details</h2>

            <div className="container">
              <div className="row">
                <div className="col">
                  <label className="disabled">Email Address:*</label>
                  <input
                    type="text"
                    name="email"
                    value={registerForm?.email}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      <React.Fragment>
        {stateRegister === 2 && (
          <React.Fragment>
            <h1 className="select-category-txt">
              Pharmacy Re-Registration Form
            </h1>

            <hr className="green-hr" />

            <div className="confirm">
              On behalf of {registerForm?.pharmacy?.address?.name}, I agree to
              implement the following risk minimisation procedures when dealing
              with prescriptions for lenalidomide as specified by Accord
              Healthcare Ireland Ltd, Clonmel Healthcare Ltd, Mylan Ireland
              Limited or Teva Pharmaceuticals Ireland Ltd in the{" "}
              <a
                rel="noreferrer"
                href={HealthcareProfessionalInformationGuide}
                target="_blank"
              >
                Lenalidomide Healthcare Professional Information Guide.
              </a>
            </div>

            <React.Fragment>
              <div className="prescriber-confirmation">
                <label htmlFor="confirmation_terms" className="custom-checkbox">
                  1. I have read and understood the{" "}
                  <a
                    rel="noreferrer"
                    href={HealthcareProfessionalInformationGuide}
                    target="_blank"
                  >
                    Lenalidomide Healthcare Professional Information Guide.
                  </a>
                  .*
                  <input
                    type="checkbox"
                    id="confirmation_terms"
                    name="confirmation_terms"
                    checked={registerForm?.confirmation_terms}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>
                <label
                  htmlFor="confirmation_reqs_compliance"
                  className="custom-checkbox"
                >
                  2. All pharmacists who dispense Lenalidomide will have read
                  and understood the{" "}
                  <a
                    rel="noreferrer"
                    href={HealthcareProfessionalInformationGuide}
                    target="_blank"
                  >
                    Lenalidomide Healthcare Professional Information Guide.
                  </a>
                  .*
                  <input
                    type="checkbox"
                    id="confirmation_reqs_compliance"
                    name="confirmation_reqs_compliance"
                    checked={registerForm?.confirmation_reqs_compliance}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label htmlFor="confirmation_auth" className="custom-checkbox">
                  3. If supplied with Lenalidomide, it will only be used for the
                  purpose of dispensing the product by the Pregnancy Prevention
                  Programme registered pharmacy to the patient.*
                  <input
                    type="checkbox"
                    id="confirmation_auth"
                    name="confirmation_auth"
                    checked={registerForm?.confirmation_auth}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label
                  htmlFor="confirmation_supervised"
                  className="custom-checkbox"
                >
                  4. Prescriptions for Lenalidomide will be dispensed only if
                  accompanied by a completed Prescription Authorisation Form.*
                  <input
                    type="checkbox"
                    id="confirmation_supervised"
                    name="confirmation_supervised"
                    checked={registerForm?.confirmation_supervised}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label
                  htmlFor="confirmation_aged_verification"
                  className="custom-checkbox"
                >
                  5. The pharmacist dispensing Lenalidomide will check each
                  prescription and Prescription Authorisation Form for
                  completeness and approve the authorisation form prior to
                  dispensing.*
                  <input
                    type="checkbox"
                    id="confirmation_aged_verification"
                    name="confirmation_aged_verification"
                    checked={registerForm?.confirmation_aged_verification}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label htmlFor="confirmation_other" className="custom-checkbox">
                  6. Lenalidomide will be dispensed, checked and stored
                  according to our standard documented procedures for oral
                  anti-cancer medicines.*
                  <input
                    type="checkbox"
                    id="confirmation_other"
                    name="confirmation_other"
                    checked={registerForm?.confirmation_other}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label
                  htmlFor="confirmation_other1"
                  className="custom-checkbox"
                >
                  7. Dispensing will be limited to no more than a 4 week supply
                  for women of childbearing potential, and 12 weeks for males
                  and women of non-childbearing potential.*
                  <input
                    type="checkbox"
                    id="confirmation_other1"
                    name="confirmation_other1"
                    checked={registerForm?.confirmation_other1}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label
                  htmlFor="confirmation_other2"
                  className="custom-checkbox"
                >
                  8. Dispensing of Lenalidomide to women of childbearing
                  potential should occur within 7 days of the prescription.*
                  <input
                    type="checkbox"
                    id="confirmation_other2"
                    name="confirmation_other2"
                    checked={registerForm?.confirmation_other2}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>

                <label
                  htmlFor="confirmation_other3"
                  className="custom-checkbox"
                >
                  9. I will update my contact details in the patientsafetyhub.ie
                  in the event of any changes.*
                  <input
                    type="checkbox"
                    id="confirmation_other3"
                    name="confirmation_other3"
                    checked={registerForm?.confirmation_other3}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>
              </div>
              <div className="confirm">
                By clicking ‘Register’, I understand that registration to obtain
                and supply lenalidomide will only be granted if I agree to items
                1–9 described above as supply of lenalidomide without
                participation in the required risk minimisation for pregnancy
                prevention is contrary to the conditions of the marketing
                authorisation. Registration is valid for 2 years at which point
                I will confirm that we are continuing to follow the risk
                minimisation procedures by completing this form.
              </div>
            </React.Fragment>

            <div className="container sign">
              <div className="row">
                <div className="col">
                  <label>Pharmacist Name*</label>
                  <input
                    type="text"
                    name="pharmacistName"
                    value={
                      registerForm?.first_name + " " + registerForm?.last_name
                    }
                    disabled
                  />
                </div>
                <div className="col">
                  <label>Date:*</label>
                  <input
                    className="transparent-background"
                    value={moment().format("DD / MM / YYYY")}
                    disabled
                  />
                  <img src={Calendar} alt="Calendar" className="calendar" />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};
export default ReRegisterFormPharmacy;
